import './PassengerInformation.scss';
import { Dispatch, SetStateAction } from 'react';
import { Field } from '../../models/home';
import { handleOnChangeEmail, handleOnChangeText } from '../../helpers/form';
import { useTranslation } from 'react-i18next';
import { VALIDATION_TYPE } from '../../constants/common';
import AppText from '../AppCommon/AppText/AppText';

interface Props {
    fields: Field[];
    setFields: Dispatch<SetStateAction<Field[]>>;
}

const PassengerInformation = ({fields, setFields}: Props) => {
    const { t } = useTranslation();

    return (
        <div className="c-passenger-info">
            <div className="c-row">
                <AppText
                    label={t('labels.firstName')}
                    width={50}
                    error={fields[0].requiredError ? true : false}
                    helperText={fields[0].requiredError}
                    maxLength={52}
                    value={fields[0].value}
                    onChange={e => handleOnChangeText(e, 0, setFields, VALIDATION_TYPE.nonNumeric)}
                />
                <AppText
                    label={t('labels.lastName')}
                    width={50}
                    error={fields[1].requiredError ? true : false}
                    helperText={fields[1].requiredError}
                    maxLength={52}
                    value={fields[1].value}
                    onChange={e => handleOnChangeText(e, 1, setFields, VALIDATION_TYPE.nonNumeric)}
                />
            </div>

            <div className="c-row c-row-second">
                <AppText
                    label={t('labels.email')}
                    width={50}
                    error={fields[2].error || fields[2].requiredError ? true : false}
                    helperText={fields[2].error || fields[2].requiredError}
                    value={fields[2].value}
                    onBlur={e => handleOnChangeEmail(
                        e,
                        t('validations.email'),
                        t('validations.emailMatch'),
                        2,
                        3,
                        fields[3].value,
                        setFields
                    )}
                    onChange={e => handleOnChangeText(e, 2, setFields)}
                />
                <AppText
                    label={t('labels.confirmEmail')}
                    width={50}
                    error={fields[3].error || fields[3].requiredError ? true : false}
                    helperText={fields[3].error || fields[3].requiredError}
                    value={fields[3].value}
                    onBlur={e => handleOnChangeEmail(
                        e,
                        t('validations.email'),
                        t('validations.emailMatch'),
                        3,
                        2,
                        fields[2].value,
                        setFields
                    )}
                    onChange={e => handleOnChangeText(e, 3, setFields)}
                />
            </div>
        </div>
    );
};

export default PassengerInformation;